import { render, staticRenderFns } from "./services.vue?vue&type=template&id=60e6362c&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"
import style0 from "./services.vue?vue&type=style&index=0&id=60e6362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6362c",
  null
  
)

export default component.exports